import { ThreadsInfluencers, ThreadsInfluencerProfile } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSelectSocialAccountsForPackage } from './hooks';

export const ThreadsPackageInfluencersSearch = () => {
  const { getCurrentProfiles, getSortSelectButtonProps, getListSelectButtonProps } =
    useSelectSocialAccountsForPackage<ThreadsInfluencerProfile>({ socialMedia: InfluencersTabType.THREADS });

  return (
    <ThreadsInfluencers
      isPackagePage
      getCurrentProfiles={getCurrentProfiles}
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
